// extracted by mini-css-extract-plugin
export var gif = "_gv-0";